import TimeSelect from './TimeSelect';

function TimeRangeSelect({
  startValue,
  onStartChange,
  endValue,
  onEndChange,
  startPlaceholder = 'Start',
  endPlaceholder = 'End',
  defaultHighlight = '12:00',
  disabled = false,
}) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 min-w-0">
        <TimeSelect
          value={startValue}
          onChange={onStartChange}
          placeholder={startPlaceholder}
          defaultHighlight={defaultHighlight}
          disabled={disabled}
        />
      </div>
      <span className={`text-sm ${disabled ? 'text-slate-300' : 'text-slate-400'}`}>–</span>
      <div className="flex-1 min-w-0">
        <TimeSelect
          value={endValue}
          onChange={onEndChange}
          placeholder={endPlaceholder}
          defaultHighlight={startValue ?? defaultHighlight}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default TimeRangeSelect;
